import React from 'react';

const Payment = () => {
    return (
        <div>
            <h3 className="text-center text-warning">Payment Feature is coming soon.</h3>
        </div>
    );
};

export default Payment;